import { aiBackfillPaths } from '../domain/ai/aiBackfillPaths';
import { aiPaths } from '../domain/ai/aiPaths';
import { aiQueuePaths } from '../domain/ai/aiQueuePaths';
import { aiSearchPaths } from '../domain/ai/aiSearchPath';
import { aiUsagePaths } from '../domain/ai/aiUsagePaths';
import { amsterdamOverspanningenPaths } from '../domain/amsterdamOverspanningen/amsterdamOverspanningenPaths';
import { amsterdamOverspanningenBasisGegevensPaths } from '../domain/amsterdamOverspanningenBasisGegevens/amsterdamOverspanningenBasisGegevensPaths';
import { crowBeeldKwaliteitPaths } from '../domain/crowBeeldkwaliteit/crowBeeldkwaliteitPaths';
import { utProjectPaths } from '../domain/drone/utProject/utProjectPaths';
import { droneLabelPaths } from '../domain/droneLabel/droneLabelPaths';
import { equipmentPaths } from '../domain/equipment/equipmentPaths';
import { equipmentAssetPaths } from '../domain/equipmentAsset/equipmentAssetPaths';
import { equipmentFieldValuePaths } from '../domain/equipmentFieldValue/equipmentFieldValuePaths';
import { equipmentHistoryPaths } from '../domain/equipmentHistory/equipmentHistoryPaths';
import { equipmentTypePaths } from '../domain/equipmentType/equipmentTypePaths';
import { equipmentTypeFieldPaths } from '../domain/equipmentTypeField/equipmentTypeFieldPaths';
import { equipmentUsagePaths } from '../domain/equipmentUsage/equipmentUsagePaths';
import { publicEquipmentUsagePaths } from '../domain/equipmentUsage/publicEquipmentUsagePaths';
import { failureModePaths } from '../domain/failureMode/failureModePaths';
import { flightLogPaths } from '../domain/flightLog/flightLogPaths';
import { fmecaFurtherInvestigationPaths } from '../domain/fmecaFurtherInvestigation/fmecaFurtherInvestigationPaths';
import { inspectionFormPaths } from '../domain/inspectionForm/inspectionFormPaths';
import { inspectionTemplatePaths } from '../domain/inspectionTemplate/inspectionFormPaths';
import { nen3140Paths } from '../domain/nen3140/nen3140Paths';
import { compositionPaths } from '../domain/object/object/compositionPaths';
import { objectPaths } from '../domain/object/object/objectPaths';
import { objectManageLabelsPaths } from '../domain/object/objectLabel/objectLabelPath';
import { objectRelationPaths } from '../domain/object/objectRelation/objectRelationPaths';
import { objectTypePaths } from '../domain/objectType/objectTypePaths';
import { rovLabelPaths } from '../domain/rovLabel/rovLabelPaths';
import { objectTypeFieldPaths } from '../domain/settings/objectType/objectTypeFieldPaths';
import { surveyPaths } from '../domain/survey/survey/surveyPaths';
import { surveyCommentPaths } from '../domain/survey/surveyComment/surveyCommentPaths';
import { surveyManageLabelsPaths } from '../domain/survey/surveyLabel/surveyLabelPath';
import { surveyMobilePaths } from '../domain/survey/surveyMobile/surveyMobilePaths';
import { surveyTaskPaths } from '../domain/survey/surveyTask/surveyTaskPaths';
import { surveyVideoStreamPaths } from '../domain/survey/surveyVideoStream/surveyVideoStreamPaths';
import { surveyWorkflowEmployeePaths } from '../domain/survey/surveyWorkflowEmployee/surveyWorkflowEmployeePaths';
import { surveyInvestigationPaths } from '../domain/surveyInvestigation/surveyInvestigationPaths';
import { surveyPointCloudPaths } from '../domain/surveyPointCloud/surveyPointCloudPaths';
import { surveyScopeExclusionPaths } from '../domain/surveyScopeExclusion/surveyScopeExclusionPaths';
import { taskDefinitionPaths } from '../domain/taskDefinition/taskDefinitionPaths';
import { userPaths } from '../domain/user/userPaths';
import { verificatieBerekeningPaths } from '../domain/verificatieBerekening/verificatieBerekeningPaths';
import { workerPaths } from '../domain/worker/workerPaths';
import { workerApiPaths } from '../domain/workerApi/workerApiPaths';
import { zxyDataExchangePaths } from '../domain/zxyDataExchange/zxyDataExchangePaths';
import { zxyRegisterPaths } from '../domain/zxyRegister/zxyRegisterPaths';

export const openApiPaths = {
    ...aiBackfillPaths,
    ...aiPaths,
    ...aiQueuePaths,
    ...aiSearchPaths,
    ...aiUsagePaths,
    ...compositionPaths,
    ...droneLabelPaths,
    ...failureModePaths,
    ...fmecaFurtherInvestigationPaths,
    ...nen3140Paths,
    ...objectPaths,
    ...objectRelationPaths,
    ...objectTypeFieldPaths,
    ...rovLabelPaths,
    ...surveyInvestigationPaths,
    ...surveyPaths,
    ...surveyMobilePaths,
    ...surveyScopeExclusionPaths,
    ...surveyTaskPaths,
    ...surveyManageLabelsPaths,
    ...objectManageLabelsPaths,
    ...userPaths,
    ...verificatieBerekeningPaths,
    ...zxyDataExchangePaths,
    ...zxyRegisterPaths,
    ...workerPaths,
    ...workerApiPaths,
    ...amsterdamOverspanningenPaths,
    ...amsterdamOverspanningenBasisGegevensPaths,
    ...surveyPointCloudPaths,
    ...utProjectPaths,
    ...objectTypePaths,
    ...equipmentTypePaths,
    ...equipmentTypeFieldPaths,
    ...equipmentPaths,
    ...equipmentFieldValuePaths,
    ...publicEquipmentUsagePaths,
    ...equipmentAssetPaths,
    ...equipmentUsagePaths,
    ...equipmentHistoryPaths,
    ...flightLogPaths,
    ...surveyCommentPaths,
    ...surveyWorkflowEmployeePaths,
    ...taskDefinitionPaths,
    ...surveyVideoStreamPaths,
    ...crowBeeldKwaliteitPaths,
    ...inspectionFormPaths,
    ...inspectionTemplatePaths,
} as const;
